import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";
import { useDispatch, useSelector } from "react-redux";
import PaginationAndSearching from "../../../components/Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../../components/SkeltonTable/skeletonTable";
import { getUserByPropIdApi } from "../../../../service/property/getUserByPropId";

export const AssigningVendorTable = ({
  column,
  rowsArr,
  handleVerify,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  handleDeleteById,
  handleTabExpanded,
  userArr,
  handleActionMultipleApprove,
  handleSeeVendor,
  handleEditVendor,
  onSelectedRowsChange 
}) => {
  const { permissionArr } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const columns = useMemo(() => column, []);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const userData = useMemo(() => userArr, [userArr]);
  const [checkedRows, setCheckedRows] = useState([]);
  const tableInstance = useTable({ columns, data }, useSortBy);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = tableInstance;

  useEffect(() => {}, [userArr]);


  const handleCheckboxChange = (row) => {
    setCheckedRows((prevCheckedRows) => {
      console.log(prevCheckedRows,"hh")
      const isChecked = prevCheckedRows.some(checkedRow => checkedRow.Id === row.Id);
      const updatedCheckedRows = isChecked
        ? prevCheckedRows.filter(checkedRow => checkedRow.Id !== row.Id)
        : [...prevCheckedRows, row];

      onSelectedRowsChange(updatedCheckedRows); // Pass the updated selected rows to parent
      return updatedCheckedRows;
    });
  };

  return (
    <>
      <div className="card">
        <div className="card-header">
          <div className="d-flex justify-content-end" style={{ width: '100%' }}>
            <div className="service-input-group input-group" style={{ width: "220px" }}>
              <span className="input-group-text search-input-icon">
                <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
              </span>
              <input
                type="text"
                className="form-control search-input"
                id="val-username1"
                placeholder="Search..."
                name="username"
                value={searchValuePagination}
                onChange={handleSearchPagination}
              />
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display" style={{ zoom: '0.9' }}>
                {!showLoading && <>
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps(column.getSortByToggleProps())}
                            style={{ color: "rgba(23, 90, 169, 0.78)" }}
                          >
                            {column.render("Header")}
                            <span className="ml-1">
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: "0.7" }} />
                                ) : (
                                  <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: "0.7" }} />
                                )
                              ) : (
                                <i className="fa fa-sort ms-2 fs-14" style={{ opacity: "0.3" }} />
                              )}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {rows.map((row, rowIndex) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell, cellIndex) => {
                            const firstCol = cellIndex === 0;
                            const SecondCol = cellIndex === 1;
                            return (
                              <td {...cell.getCellProps()} style={{ color: "black", whiteSpace: 'normal' }}>
                                {firstCol ? (
                                  <div>
                                    <input
                                      type="checkbox"
                                      checked={checkedRows.some(checkedRow => checkedRow.Id === row.original.Id)}
                                      onChange={() => handleCheckboxChange(row.original)}
                                    />
                                  </div>
                                ) : (
                                  <div>
                                    {
                                                                          (cell.column.id === "VendorName" && (
                                                                           <>
                                                                           <div style={{ marginLeft: '15px', maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} 
     title={rows[rowIndex].original.VendorName}>
  {SecondCol && rows[rowIndex].original.VendorName}
</div></> 
                                                                          ))||
                                    (cell.column.id === "VendorEmail" && (
  <div>
    {cell.value.split(/[,/]/).map((email, index) => (
      <div key={index}>{email}</div>
    ))}
  </div>
)) ||                                    (cell.column.id === "VendorPhone" && (
  <div>
    {cell.value.split(/[,/]/).map((email, index) => (
      <div key={index}>{email}</div>
    ))}
  </div>
)) || cell.render("Cell")  }
</div>
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </>}
                {showLoading && <SkeletonTableRow cols={4} row={4} />}
                {rows.length === 0 && (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    No record found
                  </div>
                )}
              </table>
              <PaginationAndSearching
                handleSearch={handleSearchPagination}
                searchValue={searchValuePagination}
                defaultValue={pageSizePagination}
                handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                totalCount={totalCountPagination}
                onChange={(e, p) => {
                  handleOnChangePagination(e, p);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssigningVendorTable;
